// theme_colors.js

let primaryHslBase = "135";
// if (!!main.theme && main.theme === "purple") {
//   primaryHslBase = primaryHslPurple;
// } else if (!!main.theme && main.theme === "teal") {
//   primaryHslBase = primaryHslTeal;
// } else if (!!main.theme && main.theme === "gray") {
//   primaryHslBase = primaryHslGray;
// }

const primaryHslLight = {
  base:                 `hsl(${primaryHslBase}, 80%, 30%)`,       // hsla(135, 80%, 30%, 1.0);
  _base:                `hsla(${primaryHslBase}, 80%, 30%, .5)`,  // hsla(135, 80%, 30%, 0.5);
  _baseLight:           `hsla(${primaryHslBase}, 80%, 30%, .1)`,  // hsla(135, 80%, 30%, 0.5);
  baseDark:             `hsl(${primaryHslBase}, 86%, 20%)`,       // hsla(135, 86%, 20%, 1.0);
  baseHover:            `hsl(${primaryHslBase}, 81%, 35%)`,       // hsla(135, 81%, 35%, 1.0);
  baseMedium:           `hsl(${primaryHslBase}, 62%, 61%)`,       // hsla(135, 62%, 61%, 1.0);
  baseLight:            `hsl(${primaryHslBase}, 81%, 75%)`,       // hsla(135, 81%, 75%, 1.0);
  baseLightHover:       `hsl(${primaryHslBase}, 84%, 82%)`,       // hsla(135, 84%, 82%, 1.0);
  baseFooter:           `hsl(${primaryHslBase}, 73%, 82%)`,       // hsla(135, 73%, 82%, 1.0);
  baseFooter2:          `hsl(${primaryHslBase}, 26%, 74%)`,       // hsla(135, 26%, 74%, 1.0);
  baseFooter3:          `hsl(${primaryHslBase}, 73%, 70%)`,       // hsla(135, 73%, 70%, 1.0);
  baseBackground:       `hsl(${primaryHslBase}, 66%, 97%)`,       // hsla(135, 66%, 97%, 1.0);
  baseBackgroundHover:  `hsl(${primaryHslBase}, 62%, 95%)`,       // hsla(135, 62%, 95%, 1.0);
  // Special use colors
  baseDivider:          `hsl(${primaryHslBase}, 84%, 92%)`,       // hsla(135, 84%, 92%, 1.0);
  baseMedium2:          `hsl(${primaryHslBase}, 84%, 59%)`,       // hsla(135, 84%, 59%, 1.0);
  baseMedium3:          `hsl(${primaryHslBase}, 98%, 65%)`,       // hsla(135, 98%, 65%, 1.0);
};

const primaryHslDark = {
  base:                 `hsl(${primaryHslBase}, 80%, 45%)`,
  _base:                `hsla(${primaryHslBase}, 80%, 45%, .5)`,
  baseDark:             `hsl(${primaryHslBase}, 86%, 30%)`,
  baseHover:            `hsl(${primaryHslBase}, 81%, 60%)`,
  baseMedium:           `hsl(${primaryHslBase}, 62%, 61%)`,
  baseLight:            `hsl(${primaryHslBase}, 81%, 75%)`,
  baseLightHover:       `hsl(${primaryHslBase}, 84%, 82%)`,
  baseFooter:           `hsl(${primaryHslBase}, 73%, 82%)`,
  baseFooter2:          `hsl(${primaryHslBase}, 26%, 74%)`,
  baseFooter3:          `hsl(${primaryHslBase}, 73%, 70%)`,
  baseBackground:       `hsl(${primaryHslBase}, 66%, 13%)`,
  baseBackgroundHover:  `hsl(${primaryHslBase}, 62%, 10%)`,
  // Special use colors
  baseDivider:          `hsl(${primaryHslBase}, 84%, 92%)`,
  baseMedium2:          `hsl(${primaryHslBase}, 84%, 59%)`,
  baseMedium3:          `hsl(${primaryHslBase}, 98%, 65%)`,
};

const colors = {
  // Primary
  ...primaryHslLight,

  light: {  // ⬇ Accessed by _theme.colors.mode._____
    ...primaryHslLight,
    // menuBackgroundColor: "#e0ffb2",
    // menuBackgroundColor: "#eeffda",
    menuBackgroundColor: "#dddddd",
    menuBackgroundColorSel: "#f7f7f7",
    menuBorderColor: "#dddddd",
    menuTextColor: "#505050",

    containerBackgroundColor: "#ffffff",  // ⬅ Don't forget to make this match in '/packages/web/public/index.html', and in '/packages/mobile/App.js'.
    containerBackgroundColor2: "#efefef",
    containerBackgroundColor3: "#dfdfdf",
    containerBackgroundColor4: "#c3c3c3",
    containerBorderColor: "#444944",
    textColor: "#222222",
    textColor2: "#292929",
    textColor3: "#333333",
    textColor4: "#555555",
    textColor5: "#888888",
    textAccent: "#778d7c",
    textAccentLight: "#cfdcc5",
    textAccentDark: "#66786a",
    inputBackgroundColor: "#ffffff",
    inputBorderColor: "#d9d9d9",
    inputTextColor: "#222222",
    // placeholderTextColor: "#525252",
    placeholderTextColor: "#999999",
  },
  dark: {  // ⬇ Accessed by _theme.colors.mode._____
    ...primaryHslDark,
    menuBackgroundColor: "#505050",
    menuBackgroundColorSel: "#656565",
    menuBorderColor: "#505050",
    menuTextColor: "#dddddd",  // menuTextColor: "#eeffda",

    containerBackgroundColor: "#222222",  // ⬅ Don't forget to make this match in '/packages/web/public/index.html', and in '/packages/mobile/App.js'.
    containerBackgroundColor2: "#323232",
    containerBackgroundColor3: "#424242",
    containerBackgroundColor3: "#565656",
    containerBorderColor: "#444944",
    textColor: "#eeeeee",
    textColor2: "#dedede",
    textColor3: "#cecece",
    textColor4: "#aaaaaa",
    textColor5: "#888888",
    textAccent: "#66786a",
    textAccentLight: "#cfdcc5",
    textAccentDark: "#778d7c",
    inputBackgroundColor: "#222222",
    inputBorderColor: "#464646",
    inputTextColor: "#cccccc",
    // placeholderTextColor: "#9d9d9d",
    placeholderTextColor: "#565656",
  },
  accent: "#227700",  // "#227700", "#248a00",
  accentDark: "#224400",  // "#227700", "#248a00",

  // Auxiliary
  // Purple
  auxiliary: "hsl(252, 54%, 44%)",  // "hsl(258, 100%, 50%)"
  auxiliaryHover: "hsl(252, 54%, 54%)",  // "hsl(252, 100%, 65%)"
  auxiliaryBackground: "hsl(250, 100%, 96%)",
  auxiliaryHighlightThin: "hsl(250, 100%, 93%)",
  _auxiliaryHighlightThin: "hsla(250, 100%, 93%,0.5)",
  auxiliaryHighlight: "hsl(250, 100%, 89%)",
  // Teal
  auxiliary: "hsl(195, 54%, 44%)",
  auxiliaryHover: "hsl(195, 54%, 54%)",
  auxiliaryBackground: "hsl(193, 100%, 96%)",
  auxiliaryHighlightThin: "hsl(193, 100%, 93%)",
  _auxiliaryHighlightThin: "hsla(193, 100%, 93%,0.5)",
  auxiliaryHighlight: "hsl(193, 100%, 89%)",
  // Ancillary
  warn: "#ffa800",
  warnMedium: "#e79901",
  warnDark: "#ce8800",
  warnDark2: "#ff7733",
  warnHover: "#ffc34d",
  warnBackground: "#fffaf0",   // "#fff9f2",
  warnBackground2: "#ffc8aa",   // "#fff9f2",
  warnHighlightThin: "hsl(40, 100%, 93%)",  // "#ffedc9",
  warnHighlight: "hsl(40, 100%, 89%)",  // "#ffedc9",
  // Cautionary
  caution: "#dc1400",  // "#dc2800",  // "#ff5000",
  cautionDark: "#bc1400",  // "#dc2800",  // "#ff5000",
  cautionMedium: "#ff3c28",
  cautionLight: "#ff8073",
  cautionHover: "#ff2800",  // "#ff5000",  // "#ff9666",
  cautionBackground: "#fff7f5",
  cautionHighlightThin: "hsl(0, 100%, 96%)",  // "#ffd4d4",
  cautionHighlight: "hsl(0, 100%, 92%)",  // "#ffd4d4",
  _cautionHighlight: "rgba(255, 214, 214, 0.7)",  // "#ffd4d4",
  // Emphisize
  // emph: "rgb(255,235,59)",
  emph: "rgb(255,230,100)",
  _emph: "rgba(255,235,59,0.7)",
  emphDark: "rgb(255,224,96)",  // #ffe060
  emphDarkHover: "rgb(255,220,0)",  // "rgb(230,200,0)",
  emphMedium: "rgb(255,240,160)",
  emphLight: "rgb(255,250,200)",
  emphHover: "rgb(255,242,112)",
  _emphHover: "rgba(255,242,112,0.7)",
  emphBackground: "rgb(255,254,245)",  //  "#fffef5",
  emphHighlightThin: "rgb(255,249,199)",
  _emphHighlightThin: "rgba(255,249,199,0.7)",
  emphHighlight: "rgb(255,252,220)",
  _emphHighlight: "rgba(255,252,220,0.7)",
  // Success
  success: "#227700",
  successDark: "#1a5a00",
  successMedium: "#6baa55",
  successMedium2: "#88cc66",
  successLight: "#aaff88",
  successHover: "#99cc88",
  successBackground: "#f6faf5",
  successHighlightThin: "hsl(104, 52%, 92%)",
  successHighlight: "hsl(104, 52%, 87%)",// "#d6efcd",
  _successHighlight: "rgba(214, 239, 205, 0.7)",// "#d6efcd",
  newRowBg: "#e5ffe8",
  selectedBackground: "#e0e6dc",
  selectedHighBackground: "#e4f5e8",
  // Monochromatic
  monoBlack: "#1a1a1a",
  monoDark: "#444444",
  monoDark2: "#585858",
  monoMedium: "#767676",
  monoMedium2: "#888888",
  _monoMedium: "rgba(118,118,118,0.7)",
  mono: "#999999",
  monoLight: "#bfbfbf",
  monoLight2: "#cfcfcf",
  monoLight3: "#dfdfdf",
  monoDisabled: "#dadada",
  monoInputDisabled: "#eaebec",
  monoBackground: "#f2f2f2",
  // Placeholder
  placeholder: "#d0d4dc",  //"#d0d4dc" form AutoComplete
  listRowDiv: "#cad4d8",

  // Custom
  loveIt: "rgb(255,71,104)",

  black: "#000000",
  white: "#ffffff",

  ganttBorder:      "#e0e0e0",
  ganttBorderLight: "#f0f0f0",
  ganttAltRowBg:    "#f5f5f5",

};

export default colors;